module.exports = __webpack_public_path__ + "img/banner_error_plain.b3caec94.webp";